/// <reference path="appbase.ts" />


namespace TerminalApp {

    export class LocationMapping extends AppBase {
        bound = false;

        static instance: LocationMapping;
        constructor() {
            super("app_location_mapping");
            LocationMapping.instance = this;

        }



        async onOpen() {

        }

        async onClose() {
        }
    }



    RegisterApp("app_location_mapping", LocationMapping);
}